import { useTranslation } from '../i18n';
import "./Footer.css";

function Footer() {
  const { t } = useTranslation();
  
  return (
    <footer className="footer">
      <div className="footer-content">
        <nav>
          <ul>
            <li>
              <a href="#janina-charles">{t('navigation.home')}</a>
            </li>
            <li>
              <a href="#ablauf">{t('navigation.ablauf')}</a>
            </li>
            <li>
              <a href="#anreise">{t('navigation.anreise')}</a>
            </li>
            <li>
              <a href="#kontakte">{t('navigation.kontakte')}</a>
            </li>
          </ul>
        </nav>
      </div>
    </footer>
  );
}

export default Footer;
